import { IconProps } from '../../modules/icons/IconProps';
export function ThermometerState1(props: IconProps) {
    return (
        <svg
            {...props}
            width="80"
            height="354"
            viewBox="0 0 80 354"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40 0C51.0457 0 60 8.95431 60 20V279.353C71.9557 286.269 80 299.195 80 314C80 336.091 62.0914 354 40 354C17.9086 354 0 336.091 0 314C0 299.195 8.04427 286.269 20 279.353V20C20 8.95431 28.9543 0 40 0Z"
                fill="#F5F5F5"
            />
            <path
                d="M40.3936 261.833C48.6221 259.136 55.9754 261.956 56 261.966V281.744C67.8531 287.635 75.9999 299.865 76 313.999C76 333.881 59.8823 349.999 40 349.999C20.1177 349.999 4 333.881 4 313.999C4.00013 299.865 12.1469 287.635 24 281.744V261.966C24 261.966 31.3641 264.8 39.6064 262.099L40.3936 261.833Z"
                fill="#B0E2C4"
            />
        </svg>
    );
}
